import {API, graphqlOperation} from 'aws-amplify';

export async function fetchItemsNextTokenGraphQL(query, variables, items = []) {
  const { data } = await API.graphql(graphqlOperation(query, variables));
  const key = Object.keys(data).find(k => k.includes('list'));
  const res = data[key]; // res = { items: [], nextToken: '' }

  items.push(...res.items);
  if (!res.nextToken) return items;

  // eslint-disable-next-line no-param-reassign
  variables.nextToken = res.nextToken;
  return fetchItemsNextTokenGraphQL(query, variables, items);
}



// WEBPACK FOOTER //
// ./src/utils/query_all_utils.js